<app-slide-in-right-modal
    [modalTitle]="'Update MFD Distribution'"
    iconImageSrc="assets/images/svgs/document--outline.svg"
    [returnPath]="''"
    [slideOpen]="true"
>
    <div class="page__container flex flex-col pb-8">
        <p class="cta__text text-sm text-mango-gray74">
        Kindly Select date range
        </p>

        <form
        class="flex flex-col gap-5 px-0 pt-5"
        [formGroup]="dateRangeForm"

        >
        <ng-container>
        <!--Start date and end date -->
          <div
              class="form-row flex flex-col gap-5 md:grid md:grid-cols-2 md:gap-x-5"
          >
              <!-- Start date -->
              <div>
              <app-input-label
                  labelFor="start-date"
                  labelClass="label--bottom-margin"
                  >Start Date</app-input-label
              >

              <input
                  placeholder="DD/MM/YYYY"
                  
                  formControlName="start_date"
                  class="block w-full rounded-lg border-0 pl-2 text-base text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango sm:leading-6 cursor-pointer"
                  type="date"
                  
                >
              </div>

              <!-- end date -->
              <div>
              <app-input-label
                  labelFor="end-date"
                  labelClass="label--bottom-margin"
                  >End Date</app-input-label
              >

              <input
                  placeholder="DD/MM/YYYY"
                  
                  formControlName="end_date"
                  class="block w-full rounded-lg border-0 pl-2 text-base text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-mango sm:leading-6 cursor-pointer"
                  type="date"
                  
                >
              </div>
          </div>
        </ng-container>

        <div class="xl:grid xl:grid-cols-2">
            <div
              [ngClass]="{
                'cursor-not-allowed': isLoading
              }"
              class="col-start-3 justify-self-end"
            >
              <button
                (click)="seedClientsId()"
                class="w-full justify-center xl:col-start-2 xl:w-fit xl:justify-self-end cursor-pointer"
                mango-button
                [disabled]="isLoading || !dateRangeForm.valid"
                [loading]="isLoading || !dateRangeForm.valid"

              >
                <span *ngIf="isLoading" spin></span>
                {{ isLoading ? 'Updating...' : 'Update Distribution' }}
              </button>
            </div>
          </div>
        </form>
    </div>
</app-slide-in-right-modal>